import { getBuildedMatfileTemplate } from '@/helpers/matfile';

export default () => {
  const matfileTemplate = getBuildedMatfileTemplate();
  const isMatfileTemplateAvailable = !!matfileTemplate;

  if (isMatfileTemplateAvailable) {
    const $1 = /LS-(\w*)-AL/g.test(matfileTemplate.name);
    const $2 = /LS-(\w*)-V4A/g.test(matfileTemplate.name);
    const $3 = matfileTemplate.name === 'LS-EML (180X180)';
    const available = $1 || $2 || $3;

    return { available, $1, $2, $3 };
  }
  return { available: false, $1: false, $2: false, $3: false };
};
